export const events = {
  toggleLoginModal: 'toggleLoginModal',
  toggleGallerySliderModal: 'toggleGallerySliderModal',
  cookiesDisplayModal: 'cookiesDisplayModal',
  toggleVirtualTourModal: 'toggleVirtualTourModal',
};
